import {isNil, isNotNil} from 'ramda';

import {PurchasePriceRuleRequestBody} from '@dms/api/sales';

import {getSinglePurchasePriceRuleMake} from '../../../utils/getSinglePurchasePriceRuleMake';
import {PurchasePriceRuleFormValues} from '../schemas/PurchasePriceRuleFormSchema';

const toBigDecimal = (value: number | null) => (value ?? 0).toString();

/**
 * Builds the request body. The system rule keeps its original technical name and has no scope.
 * Required values are guaranteed by the validation; the `0` fallback only applies to the
 * percentage of a disabled modifier, which may have been cleared.
 */
export const formValuesToRequestBody = (
  values: PurchasePriceRuleFormValues,
  systemRuleName: string | null
): PurchasePriceRuleRequestBody => {
  const makes = values.scope.makes ?? [];
  const hasSingleMake = isNotNil(getSinglePurchasePriceRuleMake(makes));
  const lastBandIndex = values.priceBands.length - 1;

  return {
    name: systemRuleName ?? values.name.trim(),
    scope: isNil(systemRuleName)
      ? {
          makes,
          modelFamilies: hasSingleMake ? (values.scope.modelFamilies ?? []) : [],
          trims: hasSingleMake ? (values.scope.trims ?? []) : [],
        }
      : null,
    priceBands: values.priceBands.map((band, index) => ({
      upperBoundInclusive: index === lastBandIndex ? null : toBigDecimal(band.upperBound),
      margin: {type: band.marginType, value: toBigDecimal(band.marginValue)},
    })),
    warrantyCost: toBigDecimal(values.warrantyCost),
    modifiers: {
      electricVehicle: {
        enabled: values.modifiers.electricVehicle.enabled,
        percentage: toBigDecimal(values.modifiers.electricVehicle.percentage),
      },
      highMileage: {
        enabled: values.modifiers.highMileage.enabled,
        percentage: toBigDecimal(values.modifiers.highMileage.percentage),
        threshold: values.modifiers.highMileage.threshold,
      },
      higherAge: {
        enabled: values.modifiers.higherAge.enabled,
        percentage: toBigDecimal(values.modifiers.higherAge.percentage),
        threshold: values.modifiers.higherAge.threshold,
      },
    },
  };
};
